// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){

  Aedu.UserPhoto = createReactClass({
    propTypes: {
      // TODO: this breaks frontend convention
      user: PropTypes.shape({
        photo: PropTypes.string.isRequired,
        first_name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
      }).isRequired,
      size: PropTypes.string,
      index: PropTypes.number
    },

    getDefaultProps: function() {
      return {
        size: "lg",
      }
    },

    render: function(){
      var user = this.props.user;
      var size = this.props.size;
      var index = this.props.index || user.id;
      // This seems like a fragile way of determining they have no profile photo
      var hasUserPhoto = user.photo !== "/images/s65_no_pic.png";
      var avatarClasses = classNames(("Avatar--" + size), {
        "Avatar": hasUserPhoto,
      });
      var textClasses = classNames("u-letterSpacing1 u-tcWhite u-taCenter u-fw700", {
        "u-pt4x": size === "lg",
        "u-pt3x": size === "md",
        "u-pt2x": size === "sm",
        "u-pt1x": size === "xs",
        "u-fs12": size === "xs"
      });

      if (hasUserPhoto) {
        return <img className={avatarClasses} src={user.photo}></img>
      } else {
        var bgClasses = ['bg-primary', 'bg-success', 'bg-info', 'bg-warning'];
        var bgClass = bgClasses[index % bgClasses.length];
        var classes = textClasses + " " + avatarClasses + " " + bgClass;
        return (
          <div className={classes}>
            {user.first_name.slice(0,1).toUpperCase() + user.last_name.slice(0,1).toUpperCase()}
          </div>
        )
      }
    }
  });
})();
